import {Component, Input, OnInit} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";

@Component({
    selector: 'app-empty-state-live',
    templateUrl: './empty-state-live.component.html',
    styleUrls: ['./empty-state-live.component.scss'],
    standalone: false
})
export class EmptyStateLiveComponent implements OnInit {
  @Input() addPaddingBottom: boolean = true;

  formattedMessage: string | undefined;

  constructor(private translocoService: TranslocoService) {
  }

  ngOnInit(): void {
    this.translocoService.selectTranslate('emptyState.stopwatch.message').subscribe((res: string) => {
      this.formattedMessage = this.boldLastWord(res);
    });
  }

  private boldLastWord(sentence: string): string {
    let words = sentence.split(' ');
    const lastWord = words[words.length - 1];
    const lastChar = lastWord.slice(-1);
    const hasPunctuation = [".", ",", ";", "!", "?"].includes(lastChar);

    if (hasPunctuation) {
      words[words.length - 1] = `<strong>${lastWord.slice(0, -1)}</strong>${lastChar}`;
    } else {
      words[words.length - 1] = `<strong>${lastWord}</strong>`;
    }

    return words.join(' ');
  }
}
